/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const DevicesTableSummary = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    devicesTable: { deviceLabel, priceLabel, quantityLabel },
    ORDERS: { labelTotalDevices }
  } = localizedStrings;

  const totalDevices = orderData.reduce((acc, item) => acc + item.quantity, 0);
  return (
    <div className="responsive-table-container" style={{ margin: '2rem 0' }}>
      <table className="responsive-table">
        <caption className="responsive-table__caption">
          {`${labelTotalDevices} (${totalDevices})`}
        </caption>
        <thead className="responsive-table__thead">
          <tr>
            <th>#</th>
            <th>{deviceLabel}</th>
            <th>{priceLabel}</th>
            <th>{quantityLabel}</th>
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {orderData.map((item, index) => {
            const { name: device, unitPrice, quantity } = item;
            const rowKey = `row${index}`;

            return (
              <tr key={rowKey}>
                <td data-header-label="#">{index + 1}</td>
                <td data-header-label={deviceLabel}>{device}</td>
                <td data-header-label={priceLabel}>{`$${unitPrice.toFixed(2)}`}</td>
                <td data-header-label={quantityLabel}>{quantity}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

DevicesTableSummary.propTypes = {
  orderData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      unitPrice: PropTypes.number.isRequired,
      quantity: PropTypes.number.isRequired
    })
  ).isRequired
};

export default DevicesTableSummary;

